import { Button, Tag, Typography } from 'antd'
import {
  RoleColumn,
  RoleRow,
} from 'pages/reporting/shared/approval/components/approvalRoleRow'
import { FC } from 'react'

const { Text } = Typography

interface ApprovalRoleStatusRowProps {
  label: string
  assigneeName: string
  qualifications: string | undefined
  signedAt: string | undefined
  readOnly: boolean
  isBusy: boolean
  signDisabledReason: string | undefined
  onSign: () => void
}

/** One required role: who fills it, whether they have signed, and the Sign action when they can. */
export const ApprovalRoleStatusRow: FC<ApprovalRoleStatusRowProps> = ({
  label,
  assigneeName,
  qualifications,
  signedAt,
  readOnly,
  isBusy,
  signDisabledReason,
  onSign,
}) => (
  <RoleRow>
    <Text strong>{label}</Text>
    <RoleColumn>
      <Text>{assigneeName}</Text>
      <Text type='secondary'>
        {signedAt
          ? `Signed ${new Date(signedAt).toLocaleString()}`
          : qualifications}
      </Text>
    </RoleColumn>
    {signedAt ? (
      <Tag color='success'>Signed</Tag>
    ) : readOnly ? (
      <Tag>Pending</Tag>
    ) : (
      <Button
        type='primary'
        size='small'
        disabled={!!signDisabledReason || isBusy}
        title={signDisabledReason}
        onClick={onSign}>
        Sign
      </Button>
    )}
  </RoleRow>
)
